import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'

import * as beepingReportActions from 'action/BeepingReport'
import * as reportActions from 'action/report'
import { renderToastWarn } from 'utils/ToastUtils'

import CommonReport from 'component/commonReport/CommonReport'
import columns from 'component/beepingReport/columns'
import applyMask from 'component/report/utils/Formatter'

class BeepingReport extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      formData: {},
    }
  }


  static propTypes = {
    auth: PropTypes.object.isRequired,
    fetchBeepingReport: PropTypes.func,
    error: PropTypes.object,
    count: PropTypes.number.isRequired,
    records: PropTypes.array.isRequired,
    fetchReports: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
  }

  get formFields() {
    const { translate } = this.props

    return [
      {
        type: 'branchs',
        name: 'idBranches',
        label: translate('field.store'),
        help_text: translate('totalAccuracy.store'),
        required: true,
      },
      {
        type: 'text',
        name: 'cdLm',
        help_text: translate('mobile.hint.lm'),
        label: translate('field.lm.hint'),
        required: false,
        attrs: {
          maxLength: 8,
          minLength: 8,
          mask: '99999999',
        },
      },
      {
        type: 'date_range',
        name: 'dtPeriod',
        label: translate('field.period.hint'),
        help_text: translate('totalAccuracy.dtYear.filter'),
        required: true,
      },
      {
        type: 'radio_group',
        name: 'beep',
        required: true,
        initial: 3,
        options: [
          { value: 2, label: translate('beeping.beeped.only') },
          { value: 1, label: translate('beeping.unbeed.only') },
          { value: 3, label: translate('beeping.all.products') },
        ],
      },
    ]
  }

  get columns() {
    const { translate } = this.props

    return columns.reduce((reduced, col) => {
      const { field, fixed, headerLabel, align, customWidth } = col
      reduced[field] = {
        fixed,
        align,
        customWidth,
        disableOrer: false,
        label: translate(headerLabel),
      }
      return reduced
    }, {})
  }

  get rows() {
    const { translate, records } = this.props

    return (records || []).map((record) =>
      columns.reduce((reduced, col) => {
        const { type, field, headerLabel } = col
        reduced[field] =
          record[field] || record[field] === 0 || record[field] === false
            ? applyMask(type, record[field], translate, headerLabel)
            : '-'
        return reduced
      }, {})
    )
  }

  onSubmit = (data, successCallback) => {
    const {
      fetchBeepingReport,
      auth: {
        user: { dsToken },
      },
    } = this.props

    const [dtStart, dtEnd] = data.dtPeriod

    const params = {
      ...data,
      lsBranch: data.idBranches,
      beepStus: data.beep - 1,
      cdLm: data.cdLm,
      dtStart: moment(dtStart).format('YYYY-MM-DD'),
      dtEnd: moment(dtEnd).format('YYYY-MM-DD'),
    }

    this.setState({ formData: data })

    fetchBeepingReport(dsToken, params, {}).then(() => {
      if (this.props.error) {
        renderToastWarn(this.props.error)
        successCallback({
          data: [],
          total: 0,
        })
        return
      }

      successCallback({
        data: this.rows,
        total: this.props.count,
      })
    })
  }

  onExport = (successCallback) => {
    const { formData: data } = this.state
    const {
      fetchReports,
      translate,
      auth: {
        user: { dsToken },
      },
    } = this.props

    const [dtStart, dtEnd] = data.dtPeriod

    const params = {
      ...data,
      lsBranch: data.idBranches,
      beepStus: data.beep - 1,
      cdLm: data.cdLm,
      dtStart: moment(dtStart).format('YYYY-MM-DD'),
      dtEnd: moment(dtEnd).format('YYYY-MM-DD'),
    }

    fetchReports(dsToken, { tpReport: 22 }, params, translate).then(() =>
      successCallback(true)
    )
  }

  render() {
    const { translate } = this.props

    return (
      <CommonReport
        translate={translate}
        title={translate('beeping.report.menu.title')}
        onSubmit={this.onSubmit}
        fields={this.formFields}
        columns={this.columns}
        onExport={this.onExport}
        order
        defaultOrder={'date'}
        emptyReportMsg='Nenhuma bipagem encontrada'
      />
    )
  }
}

const mapStateToProps = ({
  beepingReportReducer,
  paginateReducer,
  reportReducer,
}) => ({
  count: paginateReducer.count,
  current: paginateReducer.current,
  error: reportReducer.get.error,
  pages: paginateReducer.pages,
  records: beepingReportReducer.records,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...beepingReportActions, ...reportActions }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(BeepingReport)
)
